import { render, staticRenderFns } from "./ImUser.vue?vue&type=template&id=5b79a7c6&scoped=true&"
import script from "./ImUser.vue?vue&type=script&lang=js&"
export * from "./ImUser.vue?vue&type=script&lang=js&"
import style0 from "./ImUser.vue?vue&type=style&index=0&id=5b79a7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79a7c6",
  null
  
)

export default component.exports